import { useContext } from 'react'
import DialogActionButtonsSection from './components/DialogActionButtonsSection'
import { env } from '../services/EnvironmentVariables'
import { RoomContext, RoomContextType } from '../RoomContext'
import CrossPlatformDialog from './components/CrossPlatformDialog'
import { DialogBody, DialogTitle } from '@/components/Dialog'

export default function RoomAppUpgradeRequiredDialog() {
    const { state: roomState, dispatch: roomDispatch } = useContext(RoomContext) as RoomContextType

    const onDefaultClose = () => {
        roomDispatch({
            type: 'update_room_context',
            value: {
                isRoomAppUpgradeRequiredDialogOpen: null,
            },
        })
    }

    if (roomState.isRoomAppUpgradeRequiredDialogOpen?.type === 'outdated_room') {
        return (
            <CrossPlatformDialog frameName="Dialog:RoomAppUpgradeRequiredDialog" onDefaultClose={onDefaultClose}>
                <DialogBody>
                    <DialogTitle>Could not join room due to app version mismatch</DialogTitle>

                    <div className="pb-3">
                        Your app version ({env.APP_VERSION}) is too high to join this room. This room was created by an
                        app with version lower than v1.5.0.
                    </div>
                    <div className="pb-3">
                        We recommend that the host who created this room upgrade their app to the latest version and
                        create a new room.
                    </div>
                </DialogBody>

                <DialogActionButtonsSection rightButtonText="OK" onRightButtonClicked={onDefaultClose} />
            </CrossPlatformDialog>
        )
    } else if (roomState.isRoomAppUpgradeRequiredDialogOpen?.type === 'outdated_peer') {
        // not needed now, but we keep it around.
        const username = roomState.isRoomAppUpgradeRequiredDialogOpen?.username || ''
        return (
            <CrossPlatformDialog frameName="Dialog:RoomAppUpgradeRequiredDialog" onDefaultClose={onDefaultClose}>
                <DialogBody>
                    <div className="pb-3">{username} is trying to join the room but their app version is outdated.</div>
                </DialogBody>
                <DialogActionButtonsSection rightButtonText="OK" onRightButtonClicked={onDefaultClose} />
            </CrossPlatformDialog>
        )
    } else {
        return null
    }
}
